import { Alert, AlertTitle, Button } from '@mui/material';
import { DateTime } from 'luxon';
import { BulkActivationResultItemDTO } from 'probonio-shared-ui/api';
import { useTranslation } from 'react-i18next';
import { BasicDialog, DialogState } from '../../../component/dialog';

interface Props {
  dialogState: DialogState;
  variant: 'deactivate' | 'pause';
  result: BulkActivationResultItemDTO;
}

export const SingleActivationResultDialog: React.FC<Props> = ({ dialogState, variant, result }) => {
  const { t } = useTranslation('benefitsModule');

  const variantKey = variant === 'deactivate' ? 'editDialog.deactivateResultDialog' : 'editDialog.pauseResultDialog';

  return (
    <BasicDialog
      dialogState={dialogState}
      title={t(`${variantKey}.title`)}
      content={
        <Alert severity={variant === 'pause' ? 'error' : 'warning'}>
          <AlertTitle>{t('editDialog.resultMessageTitle')}</AlertTitle>
          {t(`${variantKey}.message`, { date: result.endDate ? DateTime.fromISO(result.endDate) : undefined })}
        </Alert>
      }
      actions={
        <Button type="button" variant="contained" onClick={dialogState.handleClose}>
          {t('common:buttons.close')}
        </Button>
      }
    />
  );
};
